import React, { useState, useEffect } from "react";
import { api } from "../../utils/api";
import { 
  BarChart2, Wallet, Headphones, Settings, 
  Pin, Building, Zap, Bell, CreditCard, Megaphone, Landmark, CheckCircle 
} from "lucide-react";

// Para ve Tarih formatlayıcı araçlar
const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);
const money2 = n => new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
const fmt = d => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function ResidentHome({ resident, setActiveTab }) {
  const [balance, setBalance] = useState(0);
  const [pendingPayments, setPendingPayments] = useState([]);
  const [showPayment, setShowPayment] = useState(false);
  const [loading, setLoading] = useState(true);

  const formatMoney = (amount) => new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);

  useEffect(() => {
    const fetchTransactions = async () => {
      console.log("1. İstek atılacak hesap kodu:", resident.accounting_code); // Kodu görebiliyor muyuz?
      try {
        const apiUrl = `https://api.baskentsitesi.com.tr/api/statement/${resident.accounting_code}`;
        console.log("3. İstek atılan URL:", apiUrl);
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include' 
        });
        console.log("4. Sunucudan dönen HTTP Kodu:", response.status);
        if (!response.ok) {
          throw new Error(`Sunucu Hatası: ${response.status}`);
        }

        const data = await response.json();
        console.log("5. API'den gelen HAM VERİ:", data); // Gelen verinin içinde 'rows' var mı bakacağız
        // DÜZELTME: API'den gelen verinin içinden sadece toplam bakiyeyi çekip setBalance'a aktarıyoruz
        setBalance(data.totals.balance); 

      } catch (error) {
        console.error("Finans verisi çekilemedi:", error);
      } finally {
        setLoading(false);
      }
    };
    console.log("0. Gelen Resident Objesi:", resident);
    if (resident && resident.accounting_code) {
      fetchTransactions();
    } else {
      setLoading(false);
    }
  }, [resident]);


  const totalWithCommission = balance > 0 ? balance * 1.10 : 0;

  let balanceLabel = "Güncel Borcunuz";
  let balanceValue = `₺ ${formatMoney(balance)}`;
  let subText = null;

  if (balance < 0) {
    balanceLabel = "Güncel Alacağınız";
    balanceValue = `₺ ${formatMoney(Math.abs(balance))}`;
  } else if (balance === 0 && !loading) {
    balanceValue = "₺ 0,00";
    subText = "Teşekkürler";
  }

  return (
    <>
      <style>{`
        .mobile-app-shell { 
          background: linear-gradient(180deg, #1e293b 0%, #94a3b8 15%, #f1f5f9 35%, #f1f5f9 80%, #0f172a 100%); 
          color: #0f172a; 
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; 
          min-height: 100vh; 
        }
        .resident-home-dark { padding: 24px 20px 90px 20px; }
        
        .top-bar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; color: #1e293b; }
        .top-bar .logo-area { display: flex; align-items: center; gap: 8px; font-size: 18px; font-weight: 700; }
        
        .greeting { margin-bottom: 24px; color: #1e293b; }
        .greeting p { margin: 0; font-size: 16px; opacity: 0.8; }
        .greeting h2 { margin: 4px 0 0 0; font-size: 20px; font-weight: 700; }
        
        .section-heading { font-size: 18px; font-weight: 700; margin-bottom: 16px; color: #1e293b; }
        
        .emerald-card { 
          background-image: 
            url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400'%3E%3Cpath d='M0 100 C 150 200, 250 0, 400 100 C 550 200, 650 0, 800 100' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='2'/%3E%3Cpath d='M0 130 C 150 230, 250 30, 400 130 C 550 230, 650 30, 800 130' fill='none' stroke='rgba(255,255,255,0.05)' stroke-width='2'/%3E%3Cpath d='M0 160 C 150 260, 250 60, 400 160 C 550 260, 650 60, 800 160' fill='none' stroke='rgba(255,255,255,0.02)' stroke-width='2'/%3E%3C/svg%3E"),
            linear-gradient(135deg, #022c22 0%, #0d9488 45%, #064e3b 100%);
          background-size: cover;
          border-radius: 16px; 
          padding: 24px; 
          box-shadow: 0 15px 30px rgba(6, 78, 59, 0.4); 
          margin-bottom: 16px; 
          border: 1px solid rgba(255,255,255,0.15); 
          position: relative;
        }
        
        .card-balance-label { font-size: 13px; color: rgba(255,255,255,0.8); margin-bottom: 8px; text-align: center; font-weight: 500; }
        .card-balance-value { font-size: 38px; font-weight: 700; color: #ffffff; text-align: center; margin-bottom: 4px; letter-spacing: -1px; text-shadow: 0 2px 10px rgba(0,0,0,0.2); }
        .card-subtext { text-align: center; color: #a7f3d0; font-size: 14px; font-weight: 600; margin-bottom: 24px; height: 20px; }
        
        .card-footer { display: flex; justify-content: space-between; align-items: flex-end; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 16px; margin-top: 8px; }
        .card-user-info { font-size: 13px; color: rgba(255,255,255,0.8); font-family: monospace; letter-spacing: 1px; }
        
        .btn-pay-emerald { 
          background: linear-gradient(135deg, #d1fae5 0%, #34d399 100%); 
          color: #064e3b; 
          border: 1px solid rgba(255,255,255,0.4); 
          border-radius: 8px; 
          padding: 8px 16px; 
          font-weight: 700; 
          font-size: 12px; 
          display: flex; 
          align-items: center; 
          gap: 6px; 
          cursor: pointer; 
          box-shadow: 0 0 15px 2px rgba(52, 211, 153, 0.5); 
          position: relative;
        }
        .btn-pay-emerald::after {
          content: "";
          position: absolute;
          left: -10px;
          top: 12px;
          width: 8px;
          height: 12px;
          background: rgba(255,255,255,0.5);
          border-radius: 2px;
        }
        
        .weather-simple { text-align: center; font-size: 13px; color: #64748b; margin-bottom: 32px; display: flex; justify-content: center; align-items: center; gap: 6px; font-weight: 500; }
        
        .list-section-title { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 700; color: #334155; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
        .dark-list { background: rgba(255,255,255,0.6); backdrop-filter: blur(10px); border-radius: 16px; padding: 8px 16px; margin-bottom: 24px; border: 1px solid rgba(255,255,255,0.8); box-shadow: 0 4px 15px rgba(0,0,0,0.03); }
        .dark-list-item { display: flex; align-items: center; justify-content: space-between; padding: 16px 0; border-bottom: 1px solid rgba(0,0,0,0.05); }
        .dark-list-item:last-child { border-bottom: none; }
        
        .pano-box { background: rgba(255,255,255,0.6); backdrop-filter: blur(10px); border-radius: 16px; padding: 20px; text-align: center; color: #475569; font-size: 14px; border: 1px solid rgba(255,255,255,0.8); box-shadow: 0 4px 15px rgba(0,0,0,0.03); margin-bottom: 24px; font-weight: 500; }
      `}</style>

      <div className="resident-home-dark">
        <div className="top-bar">
          <div className="logo-area"><Building size={24} color="#1e293b" /> Başkent Sitesi</div>
          <Bell size={22} color="#1e293b" />
        </div>

        <div className="greeting">
          <p>İyi günler,</p>
          <h2>Sayın {resident.name.toUpperCase()}</h2>
        </div>

        <h3 className="section-heading">Güncel Borç / Alacak Durumu</h3>

        <div className="emerald-card">
          <div className="card-balance-label">{balanceLabel}</div>
          <div className="card-balance-value">
            {loading ? "Yükleniyor..." : balanceValue}
          </div>
          <div className="card-subtext">{subText}</div>
          
          <div className="card-footer">
            <div className="card-user-info">[{resident.villa_no} - {resident.type}]</div>
            {balance > 0 && (
              <button className="btn-pay-emerald" onClick={() => setActiveTab("payment")}>
                <CreditCard size={15} color="#064e3b" strokeWidth={2.5} /> ÖDEME YAP
              </button>
            )}
          </div>
        </div>

        <div className="weather-simple">
          <span>⛅</span> Ankara 24°
        </div>

        <div className="list-section-title">
          <Pin size={16} color="#ef4444" style={{transform: "rotate(45deg)"}} /> YAPILMASI GEREKEN ÖDEMELER
        </div>
        
        <div className="dark-list">
          {pendingPayments.map((p) => (
            <div className="dark-list-item" key={p.id}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <div style={{ marginTop: "2px" }}>{p.icon}</div>
                <div>
                  <div style={{ color: "#1e293b", fontWeight: "600", fontSize: "14px" }}>{p.title}</div>
                  <div style={{ color: "#64748b", fontSize: "12px", marginTop: "2px" }}>{p.date}</div>
                </div>
              </div>
              <div style={{ fontSize: "15px", fontWeight: "bold", color: p.displayAmount > 0 ? "#ef4444" : "#10b981", textAlign: "right" }}>
                {p.displayAmount > 0 ? `₺ ${formatMoney(p.displayAmount)}` : ""}
              </div>
            </div>
          ))}
        </div>

        <div className="list-section-title">
          <Megaphone size={16} color="#ef4444" /> SİTE PANOSU
        </div>
        <div className="pano-box">
          Yönetimden henüz yeni bir duyuru yok.
        </div>
      </div>
    </>
  );
}